import { createSelector } from 'reselect';

import { RootState } from '../store';
import { NodeState } from './node.reducer';


export const selectNodeReducer = (state: RootState): NodeState => state.node;

export const selectMyNodes = createSelector(
    selectNodeReducer,
    (node) => node.myNodes
);

export const selectNodeSelected = createSelector(
    selectNodeReducer,
    (node) => node.nodeSelected
);